import type { PreviewRun } from '@/app/(landing)/logs/components/log-history-preview/types'

export const PREVIEW_RUNS: readonly PreviewRun[] = [
  {
    id: 'support-01',
    name: 'Support assistant',
    status: 'Completed',
    duration: '1.8s',
    credits: '2',
    trigger: 'API',
    time: '10:42 AM',
    spans: [
      {
        name: 'Start',
        duration: '10ms',
        durationMs: 10,
        type: 'start_trigger',
        input: '{ "input": "How do I invite a teammate?" }',
        output: '{ "input": "How do I invite a teammate?" }',
      },
      {
        name: 'Support agent',
        duration: '1.6s',
        durationMs: 1600,
        type: 'agent',
        input: '{ "message": "How do I invite a teammate?" }',
        output:
          '{ "content": "Open workspace settings, choose Members, and invite your teammate by email." }',
      },
      {
        name: 'Response',
        duration: '190ms',
        durationMs: 190,
        type: 'response',
        input: '{ "answer": "<Support agent.content>" }',
        output:
          '{ "status": 200, "data": { "answer": "Open workspace settings, choose Members, and invite your teammate by email." } }',
      },
    ],
  },
  {
    id: 'leads-01',
    name: 'Lead enrichment',
    status: 'Completed',
    duration: '2.4s',
    credits: '3',
    trigger: 'Webhook',
    time: '10:38 AM',
    spans: [
      {
        name: 'Webhook',
        duration: '20ms',
        durationMs: 20,
        type: 'webhook',
        input: '{ "company": "Acme" }',
        output: '{ "company": "Acme" }',
      },
      {
        name: 'Research company',
        duration: '2.1s',
        durationMs: 2100,
        type: 'agent',
        input: '{ "company": "Acme" }',
        output: '{ "industry": "Software", "employeeCount": "51–200" }',
      },
      {
        name: 'Save to table',
        duration: '280ms',
        durationMs: 280,
        type: 'table',
        input: '{ "company": "Acme", "industry": "Software" }',
        output:
          '{ "success": true, "row": { "data": { "company": "Acme", "industry": "Software" } } }',
      },
    ],
  },
  {
    id: 'sync-01',
    name: 'Nightly data sync',
    status: 'Error',
    duration: '4.2s',
    credits: '1',
    trigger: 'Schedule',
    time: '10:30 AM',
    spans: [
      {
        name: 'Schedule',
        duration: '10ms',
        durationMs: 10,
        type: 'schedule',
        input: '{ "schedule": "Daily" }',
        output: '{ "triggered": true }',
      },
      {
        name: 'Fetch records',
        duration: '4.19s',
        durationMs: 4190,
        type: 'api',
        input: '{ "method": "GET", "resource": "records" }',
        output: '{ "error": "Request timed out. The source did not respond." }',
        error: true,
      },
    ],
  },
  {
    id: 'digest-01',
    name: 'Weekly digest',
    status: 'Completed',
    duration: '3.1s',
    credits: '2',
    trigger: 'Schedule',
    time: '10:24 AM',
    spans: [
      {
        name: 'Schedule',
        duration: '10ms',
        durationMs: 10,
        type: 'schedule',
        input: '{ "schedule": "Weekly" }',
        output: '{ "triggered": true }',
      },
      {
        name: 'Summarize updates',
        duration: '2.8s',
        durationMs: 2800,
        type: 'agent',
        input: '{ "updates": ["New onboarding guide", "Workspace audit"] }',
        output:
          '{ "content": "This week: an updated onboarding guide and completed workspace audit." }',
      },
      {
        name: 'Send to Slack',
        duration: '290ms',
        durationMs: 290,
        type: 'slack',
        input: '{ "channel": "team-updates" }',
        output: '{ "success": true }',
      },
    ],
  },
  {
    id: 'invoice-01',
    name: 'Invoice matching',
    status: 'Error',
    duration: '0.6s',
    credits: '0',
    trigger: 'Sim agent',
    time: '10:18 AM',
    spans: [
      {
        name: 'Start',
        duration: '10ms',
        durationMs: 10,
        type: 'start_trigger',
        input: '{ "invoice": "invoice-042.pdf" }',
        output: '{ "invoice": "invoice-042.pdf" }',
      },
      {
        name: 'Read file',
        duration: '590ms',
        durationMs: 590,
        type: 'file',
        input: '{ "fileName": "invoice-042.pdf" }',
        output: '{ "error": "File not found in this workspace." }',
        error: true,
      },
    ],
  },
]
